<bic-popup (close)="close()" [hasBackdrop]="true" [title]="selecting ? 'Sites freigeben' : 'Ergebnis der Freigabe'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (selecting) {
      <span class="text-sm text-gray-500">
        Wähle die Sites, auf die planBIC lesend zugreifen darf. Bereits freigegebene Sites sind ausgewählt –
        abgewählte werden wieder entfernt. Zum Übernehmen meldest du dich noch einmal bei Microsoft an.
      </span>
      <bic-input [placeholder]="'Site suchen …'" [value]="search" (valueChange)="onSearch($event)" [showX]="true"></bic-input>
      <div class="flex flex-col gap-3 max-h-[360px] overflow-y-auto">
        @for (site of filteredSites; track site.siteId) {
          <label class="flex flex-row items-start gap-3 cursor-pointer">
            <input type="checkbox" class="w-4 h-4 mt-0.5 !text-green bg-gray-50 rounded focus:ring-[none] border border-gray-300"
                   [checked]="selected.has(site.siteId!)" (change)="toggle(site)">
            <div class="flex flex-col min-w-0">
              <span class="text-sm text-gray-900">{{ site.displayName }}</span>
              <span class="text-xs text-gray-500 truncate">{{ site.webUrl }}</span>
            </div>
          </label>
        } @empty {
          <span class="text-sm text-gray-500">
            {{ sites.length ? 'Keine Site passt zur Suche.' : 'Microsoft hat für dieses Konto keine Sites geliefert.' }}
          </span>
        }
      </div>
    } @else {
      @if (session.status === 'FAILED') {
        <div class="flex flex-row gap-3 text-sm text-red-600">
          <fa-icon [icon]="faCircleExclamation" class="pt-0.5"></fa-icon>
          <span>{{ session.errorMessage || 'Die Freigabe ist fehlgeschlagen.' }}</span>
        </div>
      } @else {
        @if (okCount) {
          <div class="flex flex-row gap-3 text-sm text-gray-900">
            <fa-icon [icon]="faCircleCheck" class="text-green pt-0.5"></fa-icon>
            <span>{{ okCount }} {{ okCount === 1 ? 'Änderung wurde' : 'Änderungen wurden' }} übernommen.</span>
          </div>
        }
        @for (result of failedResults; track result.siteId) {
          <div class="flex flex-row gap-3 text-sm">
            <fa-icon [icon]="faCircleExclamation" class="text-red-600 pt-0.5"></fa-icon>
            <div class="flex flex-col">
              <span class="text-gray-900">{{ actionText(result) }}: {{ result.displayName }}</span>
              <span class="text-gray-500">{{ result.message }}</span>
            </div>
          </div>
        }
      }
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    @if (selecting) {
      <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
      <bic-button [loading]="busy" [disabled]="busy || changeCount === 0" (onClick)="apply()">Änderungen übernehmen</bic-button>
    } @else {
      <bic-button (onClick)="close()">Schließen</bic-button>
    }
  </div>
</bic-popup>
